import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert, Cascader
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons'
import moment from 'moment';
import Remark from "../public/remark";

const {SHOW_CHILD} = Cascader;
const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.dwtype = 1
        fetch('/Contract/doview', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Contract/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.state.condition.id,
                    dwtype: 1
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (this.state.condition.id) {
                        that.setState({
                            condition: data.data,
                        })
                        setTimeout(() => {
                            if (data.data.yq_id) {
                                that.getRoom(data.data.yq_id, 0)
                            }
                            if (data.data.room) {
                                that.getmianji(data.data.room, 0)
                            }
                        })
                    }
                    that.setState({
                        // room_react: data.room_react ? data.room_react : [],
                        yq_react: data.yq_react ? data.yq_react : [],
                        company_react: data.company_react ? data.company_react : [],
                        cncost_fd_react: data.cncost_fd_react ? data.cncost_fd_react : [],
                        czwt_react: data.czwt_react ? data.czwt_react : [],
                    })
                })
        } else {
            that.props.refresh()
            that.setState({
                condition: {
                    id: this.props.id,
                },
                loading: false
            })
        }
    }

    getmianji = (value, jisuan = 1) => {
        let that = this
        fetch('/Contract/getmianji', {
            method: "POST",
            body: JSON.stringify({
                room: value,
            })
        })
            .then(res => res.json())
            .then(data => {
                let condition = Object.assign({}, this.state.condition, {mianji: data.area})
                this.setState({
                    condition
                })
                if (jisuan == 1) {
                    setTimeout(() => {
                        that.calcfy()
                    })
                }
            })
    }
    calcfy = () => {
        let {rent, service, mianji, guarantee, zjbz, glfwfbz} = this.state.condition
        let arr = {}
        // 保证金 = 月度应收租赁费 * 2   rent * 2
        if (!guarantee && rent) {
            arr.guarantee = (rent * 2).toFixed(2)
        }
        // 租金标准 = 月度应收租赁费 / 面积
        if (rent && mianji && !zjbz) {
            arr.zjbz = (rent / mianji).toFixed(2)
        }
        // 管理服务费标准 = 月度应收管理服务费 / 面积
        if (service && mianji && !glfwfbz) {
            arr.glfwfbz = (service / mianji).toFixed(2)
        }
        // 月度应收租赁费 = 面积 * 租金标准
        if(!rent && zjbz){
            arr.rent = (mianji * zjbz).toFixed(2)
            if (!guarantee && arr.rent) {
                arr.guarantee = (arr.rent * 2).toFixed(2)
            }
        }
        // 月度应收管理服务费 = 面积 * 管理服务费标准
        if(!service && glfwfbz){
            arr.service = (mianji * glfwfbz).toFixed(2)
        }
        console.log(arr)
        let condition = {...this.state.condition, ...arr}
        this.setState({
            condition
        })
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, {[name + '1']: dateStrings[0], [name + '2']: dateStrings[1]})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
        if (name == 'yq_id') {
            setTimeout(() => {
                that.getRoom(value)
            })
        }
        if (name == 'room') {
            setTimeout(() => {
                that.getmianji(value)
            })
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Radio value={item.id} key={index}>{item.name}</Radio>
            )
        }
    }

    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name}</Checkbox>
            )
        }
    }

    editorChange = (editorState) => {
        let data = Object.assign({}, this.state.condition, {editorState: editorState, dwjj: editorState.toHTML()})
        this.setState({
            condition: data
        })
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({loading2: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, {[name]: fjlist})
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, {[name]: fjlist})
        this.setState({
            condition: data,
        })
    }

    getRoom = (value, isclear = 1) => {
        let that = this
        fetch('/Contract/getRoom', {
            method: "POST",
            body: JSON.stringify({
                yq_id: value,
                id: that.props.id,
                company_id: this.state.condition.company_id
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }
                if (isclear == 1) {
                    let condition = Object.assign({}, this.state.condition, {room: null, mianji: 0})
                    that.setState({
                        condition,
                    })
                }
                that.setState({
                    room_react: data.data ? data.data : []
                })
            })
    }

    onSelSearch = (name, value) => {
        let that = this
        let condition = Object.assign({}, this.state.condition, {newfield: value})
        that.setState({
            condition,
        })
        fetch('/Ajax/searchCompany', {
            method: "POST",
            body: JSON.stringify({
                name: value,
            })
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    [name]: data
                })
            })

    }

    addItem_qiye = () => {
        let that = this
        let newfield = that.state.condition.newfield
        fetch('/Check/AddCompany', {
            method: "POST",
            body: JSON.stringify({
                newfield
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    let condition = Object.assign({}, this.state.condition, {
                        newfield: null,
                        company_id: data.company_id ? data.company_id : null
                    })
                    this.setState({
                        condition: condition,
                        company_react: data.company_react ? data.company_react : []
                    })
                } else {
                    message.error(data.msg)
                }
            })
    }

    clearNewField = (open) => {
        let that = this
        setTimeout(() => {
            let condition = Object.assign({}, that.state.condition, {newfield: null})
            that.setState({
                condition: condition,
            })
        });
    }

    getMonthDifferencePrecise(startDate, endDate,name) {
        let that = this
        const start = new Date(startDate);
        const end = new Date(endDate);

        // 计算时间戳差值（毫秒）
        const timeDiff = end.getTime() - start.getTime();

        // 将时间差转换为月数（使用平均每月毫秒数）
        // 注意：平均每月毫秒数 = 365.25天/年 ÷ 12个月 × 24小时 × 60分钟 × 60秒 × 1000毫秒
        const avgMonthInMs = (365.25 * 24 * 60 * 60 * 1000) / 12;
        const months = Math.round(timeDiff / avgMonthInMs);

        let value = that.state.condition[name]
        // console.log(value,months)
        if(!value){
            let condition = Object.assign({}, that.state.condition, {[name]: months})
            that.setState({
                condition: condition,
            })
        }
        // return months;
    }
    render() {

        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :

                    <>
                        <Button type="primary" icon={<PlusOutlined/>}
                                onClick={this.mdchange.bind(this)}>新增合同</Button>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900} visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="企业名称"
                                    required={true}
                                >
                                    <Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.company_id ? this.state.condition.company_id : []}
                                        onChange={this.onSelChange.bind(this, 'company_id')}
                                        onSearch={this.onSelSearch.bind(this, 'company_react')}
                                        onDropdownVisibleChange={this.clearNewField.bind(this)}
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                <>
                                                    <Divider
                                                        style={{
                                                            margin: '8px 0',
                                                        }}
                                                    />
                                                    <Space
                                                        style={{
                                                            padding: '0 8px 4px',
                                                        }}
                                                    >
                                                        <Input placeholder="请输入"
                                                               style={{width: 250}}
                                                               value={this.state.condition.newfield ? this.state.condition.newfield : null}
                                                               onChange={this.onChange.bind(this, 'newfield')}/>
                                                        <Button type="text" icon={<PlusOutlined/>}
                                                                onClick={this.addItem_qiye.bind(this)}>
                                                            创建并选择
                                                        </Button>
                                                    </Space>
                                                </>
                                            </>
                                        )}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.company_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="合同编号"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.ref ? this.state.condition.ref : null}
                                           onChange={this.onChange.bind(this, 'ref')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="是否存在问题"
                                    // required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'czwt')}
                                                 value={this.state.condition.czwt ? this.state.condition.czwt : null}>
                                        {this.arrradio(this.state.czwt_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="租赁时间"
                                    required={true}
                                >
                                    <RangePicker style={{width: '100%'}} allowEmpty={[true, true]}
                                                 onChange={this.onRangeChange.bind(this, 'time')}
                                                 onBlur={()=>this.getMonthDifferencePrecise(this.state.condition.time1,this.state.condition.time2,'duration')}
                                                 value={[(this.state.condition.time1 ? moment(this.state.condition.time1) : null), (this.state.condition.time2 ? moment(this.state.condition.time2) : null)]}
                                                 placeholder={['请输入', '请输入']}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="租赁时长"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.duration ? this.state.condition.duration : null}
                                           onChange={this.onChange.bind(this, 'duration')} suffix={"月"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="所在位置"
                                    required={true}
                                >
                                    <Cascader options={this.state.yq_react}
                                              multiple
                                              maxTagCount="responsive"
                                              value={this.state.condition.yq_id ? this.state.condition.yq_id : null}
                                              style={{width: '100%'}} onChange={this.onSelChange.bind(this, 'yq_id')}
                                              placeholder="请选择"
                                              fieldNames={{label: 'name', value: 'id', children: 'child'}}
                                              showCheckedStrategy={SHOW_CHILD}
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label={
                                        <Space><span>选择房间</span> {this.state.condition.mianji ? <span
                                            style={{color: 'orange'}}>(面积：{this.state.condition.mianji}m²)</span> : null}
                                        </Space>}
                                    required={true}
                                >
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.room ? this.state.condition.room : []}
                                        onChange={this.onSelChange.bind(this, 'room')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                        // onBlur={() => this.getmianji(this.state.condition.room ? this.state.condition.room : [])}
                                    >
                                        {this.arrsel(this.state.room_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Divider>免租期</Divider>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="免租期时间"
                                    // required={true}
                                >
                                    <RangePicker style={{width: '100%'}} allowEmpty={[true, true]}
                                                 onChange={this.onRangeChange.bind(this, 'mz_stime')}
                                                 onBlur={()=>this.getMonthDifferencePrecise(this.state.condition.mz_stime1,this.state.condition.mz_stime2,'mz_duration')}
                                                 value={[(this.state.condition.mz_stime1 ? moment(this.state.condition.mz_stime1) : null), (this.state.condition.mz_stime2 ? moment(this.state.condition.mz_stime2) : null)]}
                                                 placeholder={['请输入', '请输入']}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="免租期月数"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.mz_duration ? this.state.condition.mz_duration : null}
                                           onChange={this.onChange.bind(this, 'mz_duration')} suffix={"月"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="月度应收管理服务费"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.mz_service ? this.state.condition.mz_service : null}
                                           onChange={this.onChange.bind(this, 'mz_service')} suffix={"元"}/>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Divider>正常期</Divider>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="正常期时间"
                                    required={true}
                                >
                                    <RangePicker style={{width: '100%'}} allowEmpty={[true, true]}
                                                 onChange={this.onRangeChange.bind(this, 'zc_stime')}
                                                 onBlur={()=>this.getMonthDifferencePrecise(this.state.condition.zc_stime1,this.state.condition.zc_stime2,'zc_duration')}
                                                 value={[(this.state.condition.zc_stime1 ? moment(this.state.condition.zc_stime1) : null), (this.state.condition.zc_stime2 ? moment(this.state.condition.zc_stime2) : null)]}
                                                 placeholder={['请输入', '请输入']}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="正常期月数"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.zc_duration ? this.state.condition.zc_duration : null}
                                           onChange={this.onChange.bind(this, 'zc_duration')} suffix={"月"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="月度应收租赁费"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           onBlur={() => this.calcfy()}
                                           value={this.state.condition.rent ? this.state.condition.rent : null}
                                           onChange={this.onChange.bind(this, 'rent')} suffix={"元"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="租金标准"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           onBlur={() => this.calcfy()}
                                           value={this.state.condition.zjbz ? this.state.condition.zjbz : null}
                                           onChange={this.onChange.bind(this, 'zjbz')} suffix={"元/月/㎡"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="月度应收管理服务费"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           onBlur={() => this.calcfy()}
                                           value={this.state.condition.service ? this.state.condition.service : null}
                                           onChange={this.onChange.bind(this, 'service')} suffix={"元"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="管理服务费标准"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           onBlur={() => this.calcfy()}
                                           value={this.state.condition.glfwfbz ? this.state.condition.glfwfbz : null}
                                           onChange={this.onChange.bind(this, 'glfwfbz')} suffix={"元/月/㎡"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="制冷费"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.zlcost ? this.state.condition.zlcost : null}
                                           onChange={this.onChange.bind(this, 'zlcost')} suffix={"元"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="采暖费"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.cncost ? this.state.condition.cncost : null}
                                           onChange={this.onChange.bind(this, 'cncost')} suffix={"元"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    label="是否浮动"
                                    // required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'cncost_fd')}
                                                 value={this.state.condition.cncost_fd ? this.state.condition.cncost_fd : null}>
                                        {this.arrradio(this.state.cncost_fd_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="保证金"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.guarantee ? this.state.condition.guarantee : null}
                                           onChange={this.onChange.bind(this, 'guarantee')} suffix={"元"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="装修保证金"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.zx_guarantee ? this.state.condition.zx_guarantee : null}
                                           onChange={this.onChange.bind(this, 'zx_guarantee')} suffix={"元"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="上传合同附件"
                                >
                                    <Row justify="space-between">
                                        <Space align="start">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                onChange={this.picChange.bind(this, 'fjlist')}
                                                multiple={true}
                                                data={{
                                                    pc: 1
                                                }}
                                            >
                                                <Button icon={<UploadOutlined/>}>上传</Button>
                                            </Upload>
                                            <Space wrap direction={"vertical"}>
                                                {this.state.condition.fjlist ? this.state.condition.fjlist.map((item, index) =>
                                                    <div>
                                                        <a href={item.url} target="_blank">{item.name} </a>
                                                        <DeleteOutlined className="hongse"
                                                                        onClick={this.delpic.bind(this, index, 'fjlist')}/>
                                                    </div>) : null}

                                            </Space>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                            {this.props.id ?
                                <Col className="gutter-row" span={24}>
                                    <Remark id={this.props.id} type={1} cate={1} notitle={1}/>
                                </Col>
                                : null}
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
